/* eslint-disable react/self-closing-comp */
import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { routePaths } from '../../../../routes/routes-path';
import { googleLogout } from '@react-oauth/google';
import { useOnClickOutside } from 'usehooks-ts';
import { LocalStorageService, RootState } from '../../../../configuration';
import { logoutAPI } from '../../../../api';
import Avatar from '../../../../components/avatar/avatar.component';
import { IUserProfile } from '../../../../models';
import { useSelector } from 'react-redux';
import DialogPayment from '../../../../components/dialog-payment';
import _ from 'lodash';

interface MenuHeaderProps {
  profile: IUserProfile | null;
}

const MenuHeader = ({ profile }: MenuHeaderProps) => {
  const isAuthenticated = useSelector(
    (state: RootState) => state.features.auth.profile
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const dropdownRef = useRef<HTMLDivElement>(null);

  const [visible, setVisible] = useState<boolean>(false);

  const handleClose = () => {
    setVisible(false);
  };

  const handleLogout = async () => {
    // SEC-10: revoke refresh token + xoá cookie httpOnly cab_rt phía server (best-effort, không chặn logout).
    try {
      await logoutAPI();
    } catch (e) {
      /* bỏ qua lỗi mạng — vẫn logout phía client */
    }
    LocalStorageService.removeItem('accessToken');
    LocalStorageService.removeItem('fingerprintHash');
    LocalStorageService.removeItem('refreshToken');

    googleLogout();
    // FULL RELOAD (không dùng navigate client-side): reset SẠCH mọi state trong bộ nhớ
    // (profile/auth của store) — nếu chỉ navigate, prompt "hoàn thiện hồ sơ" đọc từ state cũ
    // vẫn còn -> "bấm logout vẫn bị bắt hoàn thiện profile".
    window.location.href = routePaths.login;
  };

  useOnClickOutside(dropdownRef, handleClose);

  // if (!profile) {
  //   return null;
  // }
  const handleConfirm = (amount) => {
    console.log(`Confirmed amount: ${amount} VND`);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <div className="relative" ref={dropdownRef}>
      {isAuthenticated ? (
        <>
          <div
            onClick={() => setVisible((prev) => !prev)}
            className="cursor-pointer"
          >
            <Avatar
              avatar={_.get(profile, 'avatar', '')}
              label={_.get(profile, 'username', '')}
              size="sm"
            />
          </div>

          {visible && (
            <div className="absolute top-14 right-0 rounded-md max-w-[256px] w-[500px] bg-white dark:bg-gray-900 space-y-3 p-4 drop-shadow-xl">
              <ul className="text-sm text-left text-slate-800 dark:text-slate-50">
                <li>
                  <Link
                    to={routePaths.profile}
                    className="rounded-md px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-800 block w-full"
                    onClick={handleClose}
                  >
                    Trang cá nhân
                  </Link>
                </li>
                <li>
                  <a
                    href="/profile?tab=settings"
                    className="rounded-md px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-800 block w-full"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Cài đặt
                  </a>
                </li>
                <li>
                  <a
                    href="/manage/histories"
                    className="rounded-md px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-800 block w-full"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Lịch sử nạp số dư
                  </a>
                </li>
                <li>
                  <a
                    href="https://about.cab.vn/help"
                    className="rounded-md px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-800 block w-full"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Trợ giúp
                  </a>
                </li>
                <li>
                  <a
                    href="https://about.cab.vn/terms"
                    className="rounded-md px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-800 block w-full"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Điều khoản sử dụng
                  </a>
                </li>
                <li>
                  <a
                    href="https://about.cab.vn/advertising"
                    className="rounded-md px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-800 block w-full"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Quảng cáo
                  </a>
                </li>
                <li>
                  <a
                    href="https://about.cab.vn/contact"
                    className="rounded-md px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-800 block w-full"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Liên hệ
                  </a>
                </li>
              </ul>

              <Link
                to="/account/cabplus"
                className="rounded-md flex justify-center items-center gap-2 h-10 text-sm px-4 py-2 bg-violet-800 dark:bg-violet-800 text-white dark:text-gray-100 hover:bg-violet-900 dark:hover:bg-violet-800 transition duration-200 w-full"
              >
                Nâng cấp CAB+
              </Link>

              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSfszll3q2YuTJTAJ7-fetWvOz3p0Y9Uej8dALqPWpx10pBuIA/viewform?embedded=true"
                className="rounded-md flex justify-center items-center gap-2 h-10 text-sm px-4 py-2 bg-orange-800 dark:bg-orange-800 text-white dark:text-gray-100 hover:bg-orange-900 dark:hover:bg-orange-800 transition duration-200 w-full"
                target="_blank"
                rel="noreferrer"
              >
                GÓP Ý CHO CAB.VN
              </a>

              <button
                className="rounded-md flex justify-center items-center gap-2 h-10 text-sm px-4 py-2 bg-red-500 hover:bg-red-600 text-white dark:text-gray-100 transition duration-200 w-full"
                onClick={handleLogout}
              >
                Đăng xuất
              </button>
            </div>
          )}
        </>
      ) : (
        <button
          className="rounded-md flex justify-center items-center gap-2 h-10 text-sm px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white dark:text-gray-100 transition duration-200"
          onClick={() => navigate('/account/login')}
        >
          Đăng nhập
        </button>
      )}
    </div>
  );
};

export default MenuHeader;
